import styles from './index.module.css'

import type { PostCard_PostFragment } from '~publish/gql/graphql'
import GridListPost from './GridListPost'

interface GridListProps {
  gridPosts: PostCard_PostFragment[]
  timezone?: string
  hasWriteAccess?: boolean
  showExtraContent?: boolean
  onSavePostUrl: (post: PostCard_PostFragment, link: string) => void
}

const GridList = ({
  gridPosts,
  timezone = '',
  hasWriteAccess = false,
  showExtraContent = false,
  onSavePostUrl,
}: GridListProps): JSX.Element => {
  /**
   * TODO: Investigate root cause of missing assets in posts
   *
   * Issue: Some posts are being returned without assets, which is unexpected behavior
   * Current Fix: This is a safeguard to prevent page crashes when assets are missing
   *
   * @see https://linear.app/buffer/issue/CHAN-5212 for tracking
   */
  const displayedPosts = gridPosts.filter((post) => post.assets.length !== 0)

  return (
    <div className={styles.gridContainer}>
      {displayedPosts.map((post) => {
        return (
          <GridListPost
            key={`gridListPost-${post.id}-${
              post.metadata?.__typename === 'InstagramPostMetadata'
                ? post.metadata.link
                : ''
            }`}
            post={post}
            timezone={timezone}
            showExtraContent={showExtraContent}
            onSavePostUrl={onSavePostUrl}
            hasWriteAccess={hasWriteAccess}
          />
        )
      })}
    </div>
  )
}

export default GridList
